/* eslint-disable @typescript-eslint/camelcase */
import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

type Entity = 'client' | 'company' | 'environment' | 'operator' | 'partner';

export default {
  registerRole: () => `/permission/role/`,
  editRole: (role_uuid: string) => `/permission/role/${role_uuid}/`,
  getAllRoles: (operator_role: string, query: QueryProps) =>
    `/permission/role/?operator_role=${operator_role}&${objToQueryString(
      query
    )}`,
  removeRoles: () => `/permission/role/remove/`,

  getRoleInfo: (role_uuid: string) => `/permission/role/${role_uuid}/`,

  getObjects: (role_uuid: string, entity: Entity, query: QueryProps) =>
    `/permission/role/${role_uuid}/objects/${entity}/?${objToQueryString(
      query
    )}`,
  getObjectsAvailable: (role_uuid: string, entity: Entity, query: QueryProps) =>
    `/permission/role/${role_uuid}/objects/${entity}/available/?${objToQueryString(
      query
    )}`,
  registerObjects: (role_uuid: string, entity: Entity) =>
    `/permission/role/${role_uuid}/objects/${entity}/add/`,
  removeObjects: (role_uuid: string, entity: Entity) =>
    `/permission/role/${role_uuid}/objects/${entity}/remove/`,
  getPermissions: (role_uuid: string, entity: Entity) =>
    `/permission/role/${role_uuid}/permissions/${entity}/`,
  updatePermissions: (role_uuid: string, entity: Entity) =>
    `/permission/role/${role_uuid}/permissions/${entity}/full-update/`,

  toggleAddAllObjects: (
    role_uuid: string,
    entity: Entity,
    action: 'add' | 'remove'
  ) => `/permission/role/${role_uuid}/objects/${entity}/${action}/all/`,
  cloneRole: (role_uuid: string) => `/permission/role/clone/${role_uuid}/`,
};
